import React, { useState } from 'react';
import { PageMessageIconType } from 'util/enums/PageMessageIconTypeEnum';
import { AlertModal } from './AlertModal';

interface IProps {
  alertMessages: string[];
  onCloseModal: any;
  iconType?: PageMessageIconType;
  headerText?: string;
  allowCopy?: boolean;
}

interface IState {
  currentIndex: number;
  isModalOpen: boolean;
}

const MultipleAlertModal: React.FC<IProps> = (props) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isModalOpen, setIsModalOpen] = useState(props.alertMessages.length > 0 ? true : false);

  const onAlertModalClose = async () => {
    setIsModalOpen(false);
    await Promise.resolve();
    const index = currentIndex;

    if (props.alertMessages.length > index + 1) {
      setTimeout(() => {
        setCurrentIndex(currentIndex + 1);
        setIsModalOpen(true);
      }, 100);
    } else {
      props.onCloseModal();
    }
  };

  let headerText;
  if (props.iconType === PageMessageIconType.Information) {
    headerText = 'Information';
  }
  if (props.headerText) {
    headerText = props.headerText;
  }
  return (
    <AlertModal
      isModalOpen={isModalOpen}
      alertMessage={props.alertMessages[currentIndex]}
      onCloseModal={onAlertModalClose}
      iconType={props.iconType || PageMessageIconType.Warning}
      headerText={headerText}
      allowCopy={props.allowCopy}
    />
  );
};

export default MultipleAlertModal;